import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';

const UserEmailSearchQuery = gql`
  query UserEmailSearch($offset: Int, $limit: Int, $nameSearch: String) {
    getInventoryUsers(offset: $offset, limit: $limit, nameSearch: $nameSearch, onlyUsers: true) {
      id
      name
      email
      profile_picture
      has_user
    }
  }
`;

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 40,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#e3f2fd',
  }),
};

const UserEmailSearchField = ({ refetchList, onChange, value }) => {
  const loadOptions = debounce((inputValue, callback) => {
    const name = inputValue || '';
    refetchList({ nameSearch: name, offset: 0, limit: 20 }).then(response => {
      if (response.data) {
        const options = response.data.getInventoryUsers
          .filter(user => user.email)
          .map(user => ({
            label: `${user.name} (${user.email})`,
            value: user.email,
            name: user.name,
            email: user.email,
          }));
        callback(options);
      } else {
        callback([]);
      }
    });
  }, 300);

  const handleChange = (selectedOptions) => {
    onChange(selectedOptions || []);
  };

  return (
    <div style={{ minWidth: 340 }}>
      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        onChange={handleChange}
        value={value}
        placeholder="Search users to exclude..."
        styles={customStyles}
        noOptionsMessage={() => 'Type to search users'}
        getOptionLabel={(option) => option.label || `${option.name} (${option.email})`}
        getOptionValue={(option) => option.value || option.email}
      />
    </div>
  );
};

export const UserEmailExcludeSearchContainer = ({ onChange, value }) => (
  <Query query={UserEmailSearchQuery} variables={{ offset: 0, limit: 20 }} fetchPolicy="network-only">
    {({ refetch }) => (
      <UserEmailSearchField
        refetchList={refetch}
        onChange={onChange}
        value={value}
      />
    )}
  </Query>
);

UserEmailExcludeSearchContainer.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
};

UserEmailExcludeSearchContainer.defaultProps = {
  value: [],
};

export default UserEmailExcludeSearchContainer;
